import React from 'react';
import styles from '../styles/MainDisplay.module.scss';
import WeatherInfo from './layout/WeatherInfo';
import LocationInput from './layout/LocationInput';
import { WeatherData } from '../types/WeatherData';
import { VibeData } from '../services/VibeService';
import WeatherEffect from './overlays/WeatherEffect';

interface MainDisplayProps {
  weatherData: WeatherData | null;
  vibeData: VibeData | null;
  cityName: string;
  onLocationSubmit: (location: string) => void;
}

const MainDisplay: React.FC<MainDisplayProps> = ({
  weatherData,
  vibeData,
  cityName,
  onLocationSubmit,
}) => {
  const isDay = weatherData?.is_day === 1;
  const cityImage = isDay ? 'window_city_day.png' : 'window_city_night.png';

  return (
    <div className={styles['main-display']}>
      <div className={styles['window-scene']}>
        <div className={styles['glass-container']}>
          <img
            src={`/assets/${cityImage}`}
            alt="City through the window"
            className={styles['window-city']}
          />

          <WeatherEffect effect={vibeData?.effect ?? null} isDay={isDay} />
        </div>

        <img
          src="/assets/window_room.png"
          alt="Window frame and room"
          className={styles['window-room']}
        />

        <div className={styles['location-input-wrapper']}>
          <LocationInput onSubmit={onLocationSubmit} />
        </div>

        {cityName && (
          <div
            className={`${styles['city-name']} ${
              isDay ? styles['city-name--day'] : styles['city-name--night']
            }`}
          >
            {cityName}
          </div>
        )}

        {weatherData && (
          <div className={styles['weather-overlay']}>
            <WeatherInfo weatherData={weatherData} />
          </div>
        )}

        <img src="/assets/window_cat.png" alt="Cat on the sill" className={styles['cat-image']} />
      </div>
    </div>
  );
};

export default MainDisplay;
